<se-combo-cell-editor-popup
    [width]="cellWidth()"
    [comboFormControl]="formControl"
    [dataSource]="dataSource()"
    [viewValueFieldName]="viewValueFieldName()"
    [valueFieldName]="valueFieldName()"
    [multi]="multi()"
    [isResettable]="isResettable()"
    [cellReady]="cellReady()"
>
</se-combo-cell-editor-popup>
